<template>
    <el-aside class="custom-aside" style="height: calc(100vh - 50px);">
        <el-menu default-active="1" popper-effect="light" class="el-menu-vertical-demo" unique-opened
            :collapse="isCollapse" :router="true" @open="handleOpen" @close="handleClose" @select="handleSelect">

            <el-sub-menu v-for="(item) in menus" :index="item.id.toString()" :key="item.id">
                <template #title>
                    <el-icon>
                        <Odometer v-if="item.icon == 'Odometer'" />
                        <Place v-else-if="item.icon == 'Place'" />
                        <Setting v-else-if="item.icon == 'setting'" />
                    </el-icon>
                    <span>{{ item.funName }}</span>
                </template>
                <el-menu-item v-for="(i) in item.children" :index="`/main/${i.funVal}`" :key="i.id">
                    {{ i.funName }}
                </el-menu-item>
            </el-sub-menu>

            <!--
            <el-sub-menu index="2">
                <template #title>
                    <el-icon>
                        <Place />
                    </el-icon>
                    <span>场所管理</span>
                </template>
                <el-menu-item index="/main/place">场所信息</el-menu-item>
                <el-menu-item index="/main/placeDevice">场所设备</el-menu-item>
                <el-menu-item index="/main/placeDeviceCreate">场所设备预生成</el-menu-item>
            </el-sub-menu>
         
            <el-sub-menu index="3">
                <template #title>
                    <el-icon>
                        <Odometer />
                    </el-icon>
                    <span>设备管理</span>
                </template>
                <el-menu-item index="/main/supplier">供应商管理</el-menu-item>
                <el-menu-item index="/main/devmodel">设备型号管理</el-menu-item>
                <el-menu-item index="/main/devices">设备信息管理</el-menu-item>
                <el-menu-item index="/main/devcontrol">设备控制管理</el-menu-item>

            </el-sub-menu>

            <el-sub-menu index="6">
                <template #title>
                    <el-icon>
                        <setting />
                    </el-icon>
                    <span>系统管理</span>
                </template>
                <el-menu-item index="/main/role">系统角色</el-menu-item>
                <el-menu-item index="/main/user">系统用户</el-menu-item>
                <el-menu-item index="/main/org">组织机构</el-menu-item>
                <el-menu-item index="/main/permission">菜单管理</el-menu-item>
                <el-menu-item index="/main/dictionaryType">数据字典分类</el-menu-item>
                <el-menu-item index="/main/dictionary">数据字典管理</el-menu-item>
            </el-sub-menu>
           -->
        </el-menu>
    </el-aside>

    <div class="toggleCollapse">
        <el-button :icon="currentIcon" circle @click="toggleCollapse" />
    </div>
</template>

<style>
/**控制菜单的折叠和展开时的宽度，必须要 */
.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 150px;
    min-height: 400px;
    height: 100%;
}

/** 折叠和展开按钮样式 */
.toggleCollapse {
    position: absolute;
    left: 5px;
    bottom: 10px;
}

.custom-aside {
    height: 100vh;
}
</style>

<script setup>
import { ref } from "vue";
import {DArrowLeft,DArrowRight,Setting, Odometer, Place} from "@element-plus/icons-vue";
import { ElMessage } from 'element-plus';
import { router, routerMap } from '@/router/index';
import { roleApi } from '@/api/role-api';
import { getUserInf } from '@/shard/login-info-manager';


const menus = ref([]);
const isCollapse = ref(false);
const currentIcon = ref(DArrowLeft);


roleApi.getRolePermissions({roleId:getUserInf().orgId}).then((response) => {
    if (response.data.errorCode === "00000") {
        menus.value = response.data.result;
        response.data.result.forEach(item => {
            item.children.forEach(i => {
                router.addRoute("Main", routerMap[i.funVal]);
            })
        });
    }else{
        ElMessage.error("系统出错[errorCode:" + response.data.errorCode + "]");
    }
}).catch((err) =>{
    console.log(err);
});

/*
const handleOpen = (key, keyPath) => {
    //console.log(key, keyPath);
};
const handleClose = (key, keyPath) => {
    //console.log(key, keyPath);
};
const handleSelect = (i, j, k) => {
    //console.log(i,j,k);
};
*/

const toggleCollapse = () => {
    isCollapse.value = !isCollapse.value;
    if (isCollapse.value) {
        currentIcon.value = DArrowRight;
    } else {
        currentIcon.value = DArrowLeft;
    }
};
</script>